<div class="unsubscribe">
  <img src="assets/svg/access_denied.svg" alt="access denied" />
  <div class="head">Oops Sorry</div>
  <div class="subhead">
    Currently you don't have this plan, But you can have it any day coz it
    starts only from XXX amount.
  </div>
  <div class="visit" (click)="redirectToHomePage()">Visit plans</div>
</div>
